module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; 
/*var groupTitle = function (subGroup) {
    var group = groups.find(function (g) {
            return g.value === groupBy;
        }) || {};

    return subGroup ? group.subGroupTitle : group.groupTitle;
};

var toHectare = function (value) {
    if (value == null || value === '') {
        return '';
    }

    return _.round(value / 10000, 3);
};*/

    ; __append("\n\n<style>\n    .gl-report__table .center {\n        text-align: center;\n    }\n\n    .gl-report__table {\n        text-align: right;\n    }\n    .gl-report__table .left {\n        text-align: left;\n    }\n</style>\n\n<div class=\"wh100\">\n\n\n    <table class=\"w100 gl-report__table width-regulator\">\n        <thead>\n        <tr>\n            <th style=\"background-color: #eeeeee;\" colspan=\"")
    ; __append(escapeFn((groupBy=='org-cult'?2:1)))
    ; __append("\"></th>\n            <th style=\"background-color: #eeeeee;\" class=\"center\" colspan=\"")
    ; __append(escapeFn(Object.keys(data.field_names).length-(groupBy=='org-cult'?2:1) ))
    ; __append("\">Засев, Га</th>\n        </tr>\n        <tr>0\n            ")
    ;  _.each(data.field_names, function(field_name){ 
    ; __append("\n                <th>")
    ; __append(escapeFn(field_name ))
    ; __append("</th>\n            ")
    ;  }) 
    ; __append("\n        </tr>\n        </thead>\n\n")
    ; 
    var rowWrite = function (row, tagName) {
        if (row.hasOwnProperty("fields") ) _.each(row.fields, function (field) { 
    ; __append("\n            <")
    ; __append(escapeFn(tagName))
    ; __append(" ")
    ;  if(tagName=='th') {
    ; __append(" style=\"background-color: #eeeeee;\"")
    ;  } 
    ; __append(" ")
    ;  if(row.hasOwnProperty("rows")&&Object.keys(row.rows).length) { 
    ; __append(" rowspan=\"")
    ; __append(escapeFn(Object.keys(row.rows).length))
    ; __append("\"")
    ;  } 
    ; __append(">")
    ; __append(escapeFn( field ))
    ; __append("</")
    ; __append(escapeFn(tagName))
    ; __append(">\n        ")
    ;  });
        if (row.hasOwnProperty("rows") && Object.keys(row.rows).length) {
            var first = true;
            if (row.hasOwnProperty("rows")) _.each(row.rows, function (row) {
                if (!first) { 
    ; __append("\n                    </tr><tr>\n                ")
    ;  }
                rowWrite(row, 'td');
                first = false;
            });
        }
        if (row.hasOwnProperty("total") && Object.keys(row.total).length) { 
    ; __append("\n            </tr><tr>\n            ")
    ;  rowWrite(row.total, 'th'); 
    ; __append("\n            </tr><tr>\n            ")
    ; 
        }
    };

    ; __append("\n                    <tbody>\n                    ")
    ;  _.each(data.rows, function (row) { 
    ; __append("\n                        <tr>\n                            ")
    ;  rowWrite(row, 'td'); 
    ; __append("\n                        </tr>\n                    ")
    ;  }); 
    ; __append("\n                    <tr>\n                        ")
    ;  rowWrite(data.total, 'th'); 
    ; __append("\n                    </tr>\n                    </tbody>\n\n        </table>")
  }
  return __output.join("");

}